/* @flow */

import React from 'react';
import { URLBuilder } from 'url-builder/url-builder';
import PropTypes from 'prop-types';

import { UserStore } from 'four-nets/user/user';
import ErrorPage from 'four-nets/errors/error-page';

import LoadingProgress from 'lib/react-router/loading-progress';
import FetchData from 'lib/fetch-data/fetch-data';
import Localizable from 'lib/intl/localizable';

import { CategoryStore, PostStore } from './blog';
import BlogSlugLoader from './blog-slug-loader';

@Localizable()
class BlogLoader extends React.PureComponent {
    static contextTypes = {
        api: PropTypes.object,
        urlBuilder: PropTypes.instanceOf(URLBuilder),
        userStore: PropTypes.instanceOf(UserStore),
    };

    fetch = setData => {
        const { api, userStore } = this.context;
        const { intl } = this.props;

        const categoryStore = new CategoryStore({
            api,
            userStore,
        });

        const postStore = new PostStore({
            api,
            userStore,
            categoryStore,
            intl,
        });

        return categoryStore
            .loadAll({
                fields: JSON.stringify([
                    'name',
                    'slug',
                    'guid',
                    'seo',
                    ['featuredMedia', ['media_details', 'source_url']],
                ]),
            })
            .then(categories => {
                setData({
                    categories,
                    postStore,
                    categoryStore,
                });
            });
    };

    transform = data => {
        const { api, userStore } = this.context;
        const { intl } = this.props;

        const categoryStore = new CategoryStore({
            api,
            userStore,
        });

        const categories = categoryStore.processPlainJSONArray({ json: data.categories });

        const postStore = new PostStore({
            api,
            userStore,
            categoryStore,
            intl,
        });

        return {
            categories,
            postStore,
            categoryStore,
        };
    };

    renderFetch = ({ loading, error, data }) => (
        <LoadingProgress loading={loading}>
            <ErrorPage error={error}>{data ? <BlogSlugLoader {...data} /> : null}</ErrorPage>
        </LoadingProgress>
    );

    render() {
        return (
            <FetchData
                serializerKey={__filename}
                fetch={this.fetch}
                render={this.renderFetch}
                transform={this.transform}
            />
        );
    }
}

export default BlogLoader;
